import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "wfdss-alert-dialog",
    templateUrl: "./alert-dialog.component.html",
    styleUrls: ["./alert-dialog.component.scss"],
    standalone: false
})
export class AlertDialogComponent {
  message = "";
  okButtonLabel = "OK";

  ariaLabelText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AlertDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      if (data.okButtonLabel) {
        this.okButtonLabel = data.cancelLabel ?? this.okButtonLabel;
      }
      this.ariaLabelText = data.ariaLabelText;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
